const config = {
  local: 'http://localhost:8000',
  staging: 'https://staging.server.poolpartygaming.com',
  production: 'https://prod.server.poolpartygaming.com',
};

const apiUrl = config[process.env.REACT_APP_API_ENV || 'local'];

export { apiUrl };